import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import SecurityProvider from './components/SecurityProvider';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import EmergencyButton from './components/emergency/EmergencyButton';
import QuickContactBar from './components/QuickContactBar';

// Pages
import Welcome from './pages/Welcome';
import Home from './pages/Home';
import EntryResidence from './pages/EntryResidence';
import Health from './pages/Health';
import CivilFamily from './pages/CivilFamily';
import WorkHousing from './pages/WorkHousing';
import EducationJustice from './pages/EducationJustice';
import Detention from './pages/Detention';
import Documents from './pages/Documents';
import Contact from './pages/Contact';
import Consulates from './pages/Consulates';
import Search from './pages/Search';
import Wizards from './pages/Wizards';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <SecurityProvider>
      <AppProvider>
        <Router>
          <ScrollToTop />
          <Routes>
          {/* Welcome page without layout */}
          <Route path="/" element={<Welcome />} />
          
          {/* App pages with full layout */}
          <Route path="/*" element={
            <div className="min-h-screen flex flex-col bg-gradient-to-br from-white via-teal-50/30 to-teal-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
              <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
              
              <div className="flex flex-1 pt-[73px]">
                <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
                
                <main className="flex-1 overflow-x-hidden">
                  <div className="max-w-4xl mx-auto px-4 py-8 md:px-6 md:py-12 pb-24 md:pb-12">
                    <Routes>
                      <Route path="/home" element={<Home />} />
                      <Route path="/entree-sejour" element={<EntryResidence />} />
                      <Route path="/sante" element={<Health />} />
                      <Route path="/etat-civil-famille" element={<CivilFamily />} />
                      <Route path="/travail-logement" element={<WorkHousing />} />
                      <Route path="/education-justice" element={<EducationJustice />} />
                      <Route path="/detention" element={<Detention />} />
                      <Route path="/documents" element={<Documents />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/consulates" element={<Consulates />} />
                      <Route path="/search" element={<Search />} />
                      <Route path="/wizards" element={<Wizards />} />
                    </Routes>
                  </div>
                </main>
              </div>
              
              <Footer />
              <EmergencyButton />
              <QuickContactBar />
            </div>
          } />
        </Routes>
        </Router>
      </AppProvider>
    </SecurityProvider>
  );
}

export default App;
